








import traceQuery from '~/queries/trace-region.gql'

export default

	props:
		region: String
		index: Number

	data: ->
		loaded: false
		regionData: {}

	fetch: ->
		@regionData = await @$craft.execute
			query: traceQuery
			variables:
				region: @region

		@loaded = true

	computed:

		# shorthand
		currentRegion: -> @regionData?.category

		layout: ->
			if @isEven @index then return 'right'
			else return 'left'

		block: -> {
			id: @currentRegion?.id
			backgroundColor: '#FFFFFF'
			buttons: []
			customTitle: null
			componentName: 'blocks-half-marquee'
			foregroundImage: []
			icon: []
			image: @currentRegion?.image
			layout: @layout
			showLines: false
			video: null
			videoLabel: null
			videoUrl: null
			table: {}
			copy: [
				"<span class='eyebrow'>#{@currentRegion?.eyebrow}</span>"
				"<h2 class='style-h2'>#{@currentRegion?.title}</h1>"
				@currentRegion?.body
			].join ' '
		}

	methods:
		isEven: (n) -> n % 2 == 0



